import { useHistory } from 'react-router';
import { setLangToLocationDescriptor } from 'srcJs/helpers/LanguageHelper';
import app from 'srcJs/App';

var useHistoryPush = function useHistoryPush() {
  var _useHistory = useHistory(),
      push = _useHistory.push;

  return function (locationDescriptor, state) {
    var locationDescriptorNew = setLangToLocationDescriptor(locationDescriptor, app.getLang());

    if (typeof locationDescriptorNew === 'string') {
      push(locationDescriptorNew, state);
    } else {
      push(locationDescriptorNew);
    }
  };
};

export { useHistoryPush };